import React, { FC } from "react";
import { useStyles } from "./StepListStyles";

const StepList: FC = (props) => {
  const { children } = props;

  const styles = useStyles();
  return <ol className={styles.orderedList}>{children}</ol>;
};

export default StepList;
